Librarian.PageBuilder.defaultModules = {

    /* Modules with rowSpan of 1 */

    // opens to tab, pageName required
    nav: {
        type: "Nav",
        options: {
            id: "nav",
            pageName: "",
            label: ""
        }
    },

    // opens search tab
    find: { 
        type: "Nav",
        options: {
            id: "find",
            addClass: "find",
            pageName: "search",
            label: "homepage_search"
        }
    },
    // opens ecomm tab
    ecomm: { 
        type: "Nav",
        options: {
            id: "ecomm",
            addClass: "ecomm",
            pageName: "ecomm",
            label: "homepage_share"
        }
    },
    // opens specified folder
    openCat: {
        type: "OpenCat",
        options: {
            id: "openCat",
            label: "Open Category",
            path: null
        }
    },
    // opens library tab
    library: {
        type: "Nav",
        options: {
            id: "library",
            addClass: "library",
            pageName: "library",
            label: "Library"
        }
    },
    // opens ask marketing dialog
    askMarketing: {
        type: "AskMarketing",
        options: {
            id: "askMarketing",
            addClass: "askMarketing",
            label: "<span>Ask</span> Marketing",
            header: "Ask Marketing",
            email: "marketing@accent-technologies.com"
        }
    },
    // embeded ask marketing text box
    askMarketingEmbeded: {
        type: "Email",
        options: {
            id: "askMarketing",
            title: "Ask Marketing",
            email: "marketing@accent-technologies.com"
        }
    }, 
    // opens send window
    share: {
        type: "Nav",
        options: {
            id: "share",
            addClass: "share",
            label: "homepage_share",
            onClick: function () {
                this.sendWindow = new Librarian.EventSendWindow().show();
            },
            onPreDestroy: function () {
                if (this.sendWindow) {
                    this.sendWindow.close();
                    this.sendWindow = null;
                }
            }
        }
    },
    // opens portal tracker
    track: {
        type: "Nav",
        options: {
            id: "track",
            addClass: "track",
            label: "homepage_customer_responses",
            pageName: "Portal Tracker"
        }
    },
    // opens fastlane tab
    fastlane: {
        type: "Nav",
        options: {
            id: "fastlane",
            addClass: "fastlane",
            label: "Fastlane",
            pageName: "fastlane"
        }
    },
    // load given homepage layout
    changeLayout: {
        type: "Nav",
        options: {
            id: "changeLayout",
            addClass: "changeLayout",
            label: "ChangeLayout",
            pageName: "home",
            layout: "PageBuilder2.xml",
            onClick: function() {
                Librarian.PageBuilder.removeCSS();
                Librarian.treeViews.treeView.collapseTree();
                if (this.options.expandTo)
                    Librarian.treeViews.treeView.expandTreeToLevel(null, null, [this.options.expandTo]);
                else 
                    Librarian.treeViews.treeView.root.toggle(true);
                Librarian.Homepage.show("home", this.options.layout);
            }
        }
    },
    changePage: {
        type: "Nav",
        options: {
            id: "changePage",
            pageName: "home",
            onClick: function() {
                Librarian.PageBuilder.removeCSS();
                Librarian.treeViews.treeView.collapseTree();
                Librarian.Homepage.show(this.options.pageName);
            }
        }
    },
    html: {
        type: "HTML",
        options: {
            id: "html",
            title: "",
            html: ""
        }
    },
    // news module (news file must exist)
    news: {
        type: "HTML",
        options: {
            id: "news",
            addClass: "news",
            title: "homepage_breaking_news",
            fileName: "News.html"
        }
    },
    newsOrtho: {
        type: "HTML",
        options: {
            id: "news",
            addClass: "news newsOrtho",
            title: "homepage_breaking_news",
            fileName: "News.html"
        }
    },
    newsSquare: {
        type: "HTML",
        rowSpan: 2,
        options: {
            id: "news",
            addClass: "news newsSquare",
            title: "homepage_breaking_news",
            fileName: "News.html"
        }
    },

    smallHtml: {
        type: "HTML",
        
        options: {
            id: "content",
            title: "homepage_content",
            fileName: "content.html"
        }
    },

    openCatSquare: {
        type: "OpenCat",
        rowSpan: 2,
        options: {
            id: "openCat",
            label: "Open Category",
            path: null
        }
    },
    openFileSquare: {
        type: "OpenFile",
        rowSpan: 2,
        options: {
            id: "openFile",
            label: null,
            filename: null
        }
    },
    // opens playbooks tab (playbooks must be enabled)
    playbooks: { 
        type: "Nav",
        options: {
            id: "playbooks",
            addClass: "playbooks",
            label: "homepage_playbooks",
            pageName: "Playbooks"
        } 
    }, 
    // opens workspace tab
    workspace: {
        type: "Nav",
        options: {
            id: "workspace",
            addClass: "workspace",
            label: "<span>My&nbsp;</span> Workspace",
            pageName: "My Workspace"
        }
    }, 
    // opens communication manager dialog
    newMessages: {
        type: "Nav",
        options: {
            id: "newMessages",
            addClass: "newMessages",
            label: "<span>New</span> Messages",
            onClick: function () {
                this.EventManagerWindow = new Librarian.EventManagerWindow().show();
            }, 
            onPreDestroy: function() {
                if(this.EventManagerWindow) {
                    this.EventManagerWindow.close();
                    this.EventManagerWindow = null;
                }
            }
        }
    },
    // opens my contacts window
    contacts: {
        type: "Nav",
        options: {
            id: "contacts",
            addClass: "contacts",
            label: "Contacts",
            onClick: function() {
                new Librarian.MyContactsWindow().show();
            }
        }
    },
    // empty module with no functionality (use this to make invisible module)
    blank: {
        type: "Module", 
        options: {
            id: "blank",
            addClass: "blank"
        }
    }, 
    // opens recently added folder
    recentlyAdded: {
        type: "Nav",
        options: {
            id: "recentlyAdded",
            addClass: "recentlyAdded",
            label: "Recently <span>Added</span>",
            folderPath: "MasterLibrary/RecentlyAdded"
        }
    },
    thumbnail: {
        type: "Thumbnail",
        options: {
            filename: null
        }
    },
    // embed image in module
    image: {
        type: "Image",
        options: {
            id: null, 
            link: null,
            imagePath: null
        }
    },

    largeImage: {
        type: "Image",
        rowSpan: 2,
        options: {
            id: null,
            link: null,
            imagePath: null

        }
    },
    // opens url in new tab
    link: {
        type: "Link",
        options: {
            id: "link",
            label: null, 
            link: null
        }
    },
    // opens cart dialog
    build: {
        type: "Nav",
        options: {
            id: "build",
            addClass: "build",
            label: "<span>Build</span> Presentation",
            onClick: function() {
                Library.openCartWindow();
            }
        }
    },
    // opens any file (including wizards)
    openFile: {
        type: "OpenFile",
        options: {
            id: "openFile",
            label: null,
            filename: null
        }
    },
    workflow: {
        type: "Workflow",
        options: {
            id: "workflow",
            addClass: "workflow",
            label: "Submit Request",
            showHistory: false,
            isMetro: true
        }
    },
    workflowSquare: {
        rowSpan: 2,
        type: "Workflow",
        options: {
            id: "workflowSquare",
            title: "My Open Requests",
            showHistory: false,
            isMetro: true,
            isSquare: true
        }
    },
    // opens collaborate tab
    collaborate: {
        type: "Nav", 
        options: {
            id: "collaborate",
            addClass: "collaborate",
            label: "Collaborate",
            pageName: "collaboration"
        }
    },
    // opens reports to the content analytics area
    contentAnalytics: {
        type: "Reports",
        options: {
            id: "contentAnalytics",
            addClass: "contentAnalytics",
            label: "<span>Content</span></br> Analytics", 
            tabName: "Reports", 
            subtabName: "content"
        }
    }, 
    // opens reports to the sales analytics area
    salesAnalytics: {
        type: "Reports",
        options: {
            id: "salesAnalytics",
            addClass: "salesAnalytics",
            label: "<span>Sales</span> Analytics", 
            tabName: "Reports", 
            subtabName: "sales"
        }
    },
    // opens tree panel
    browse: {
        type: "Nav",
        options: {
            id: "browse",
            addClass: "browse",
            label: "<span>Browse</span> Content", 
            onClick: function() {

                // if defined, open top folder of file tree
                if(Librarian.treeViews && Librarian.treeViews.treeView && Librarian.treeViews.treeView.root) {
                    Librarian.treeViews.treeView.root.toggle(true);
                }

                Librarian.Utils.openLibraryTreePanel();
            }
        }
    },
    myFiles: {
        type: "Nav",
        options: {
            id: "myFiles",
            addClass: "myFiles",
            label: "<span>My </span> Files",
            type: null, 
            onClick: function() {
                var type = this.options.type;
                if (type){
                    Librarian.MyFiles.filter = {};
                    Librarian.MyFiles.filter[type] = true;
                }
				Library.myFilesClicked();
				Librarian.Utils.openLibraryTreePanel();
            }
        }
    },
    // retrieves popular content and opens tile list
    popularContent: {
        type: "Nav",
        options: {
            id: "popularContent",
            addClass: "popularContent",
            label: "<span>Popular</span> Content", 
            onClick: function() {

                Librarian.Utils.getPopular(20, Librarian.contentType.file, function(response) {

                    Librarian.Homepage.hide();
                    if (Librarian.features.mountedVuePages.load)
                        Librarian.Modules.MountedVuePage.hide();

                    tileList.loadFromArray(response.data);

                    var itemEl = $("pageheader");
                    if (itemEl) {
                        itemEl.show();
                    }

                    if(Librarian.pageheader != null) {
                        Librarian.pageHeader.destroy();
                        Librarian.pageHeader = null;
                    }

                    $('myInProgress').empty();

                    Librarian.pageHeader = new Librarian.PageHeader({
                        name: "Popular Content",
                        showHeaderMenu: false
                    });

                }, null, null, true);
            }
        }
    },
    // retrieves new content and opens tile list
    newContent: {
        type: "Nav",
        options: {
            id: "newContent",
            addClass: "newContent",
            label: "<span>New</span></br> Content", 
            onClick: function() {
                Librarian.Utils.getNewestFiles(20, function(response) {

                    Librarian.Homepage.hide();
                    if (Librarian.features.mountedVuePages.load)
                        Librarian.Modules.MountedVuePage.hide();

                    tileList.loadFromArray(response.data);

                    var itemEl = $("pageheader");
                    if (itemEl) {
                        itemEl.show();
                    }

                    if(Librarian.pageheader != null) {
                        Librarian.pageHeader.destroy();
                        Librarian.pageHeader = null;
                    }

                    $('myInProgress').empty();

                    Librarian.pageHeader = new Librarian.PageHeader({
                        name: "New Content",
                        showHeaderMenu: false
                    });

                }, null, null, null, true);
            }
        }
    },
    // opens uploader (must be enabled)
    upload: {
        type: "Nav", 
        options: {
            label: "Upload", 
            id: "upload",
            addClass: "upload",
            onClick: function() {
                Librarian.Utils.openUploader();
            }, 
            onPreDestroy: function() {
                if (this.uploadWindow) {
                    this.uploadWindow.close();
                    this.uploadWindow = null;
                }
            }
        }
    },
    // opens uploads area of workspace
    myUploads: {
        type: "MyUploads",
        options: {
            id: "myUploads",
            addClass: "myUploads",
            pageName: "My Workspace",
            label: "<span>My</span></br> Uploads", 
            isMooTree: false
        }
    },
    // opens favorites area of workspace
    favorites: {
        type: "MyFavorites",
        options: {
            id: "favorites",
            pageName: "My Workspace",
            label: "homepage_favorites", 
            isMooTree: false
        }
    },
    // opens my creations area of workspace
    myCreations: {
        type: "MyCreations",
        options: {
            id: "myCreations",
            addClass: "myCreations",
            label: "homepage_creations",
            pageName: "My Workspace", 
            isMooTree: false
        }
    },
    // opens recommendations tab
    recommendations: {
        type: "Nav",
        options: {
            id: "recommendations",
            addClass: "recommendations",
            label: "<span>Get</span> Suggestions",
            pageName: "recommendations"
        }
    },
    // opens bookmarks
    bookmarks: {
        type: "Nav",
        options: {
            id: "bookmarks",
            addClass: "bookmarks",
            label: "Bookmarks",
            onClick: function() {
                Librarian.Bookmarks.viewBookmarkedContents();
            }
        }
    },

    /* Modules with rowSpan of 2 */

    // same as library
    largeLibrary: {
        rowSpan: 2,
        type: "Nav",
        options: {
            id: "largeLibrary",
            addClass: "large largeLibrary",
            pageName: "library",
            title: "homepage_library",
            subTitle: "Discover resources in the library that will help you meet all of your needs."
        }
    },
    // same as uplaod
    largeUpload: {
        type: "Nav",
        rowSpan: 2,
        options: {
            title: "Upload Files to Your Workspace",
            subTitle: "Upload files to your workspace from <strong>your device</strong> or from <strong>box.com</strong>",
            id: "largeUpload",
            addClass: "large largeUpload",
            onClick: function() {
                Librarian.Utils.openUploader();
            }, 
            onPreDestroy: function() {
                if (this.uploadWindow) {
                    this.uploadWindow.close();
                    this.uploadWindow = null;
                }
            }
        }
    },
    // same as find
    largeFind: {
        rowSpan: 1,
        type: "Nav",
        options: {
            id: "largeFind",
            addClass: "large largeFind",
            pageName: "search",
            label: "", 
            title: "Search for Content"
        }
    },
    // same as build
    largeBuild: {
        rowSpan: 2,
        type: "Nav",
        options: {
            id: "largeBuild",
            addClass: "large largeBuild",
            title: "Create a Presentation",
            label: "",
            onClick: function() {
                Library.openCartWindow();
            }
        }
    },
    buildYourOwn: {
        rowSpan: 2,
        type: "Nav",
        options: {
            id: "buildYourOwn",
            addClass: "buildYourOwn",
            title: "Build Your Own",
            subTitle: "Answer a few questions and build your own customized presentation.",
            onClick: function () {
                Library.openCartWindow();
            }
        }
    },
    grabAndGo: {
        rowSpan: 2,
        type: "Nav",
        options: {
            id: "grabAndGo",
            addClass: "grabAndGo",
            pageName: "library",
            title: "homepage_library",
            subTitle: "Full pitch books that are pre-approved for use as it is."
        }
    },
    // same as workspace
    largeWorkspace: {
        rowSpan: 2,
        type: "Nav",
        options: {
            id: "largeWorkspace",
            addClass: "large largeWorkspace",
            title: "My Workspace",
            label: "",
            pageName: "My Workspace"
        }
    },
    // same as blank
    largeBlank: {
        type: "Module",
        rowSpan: 2,
        options: {
            id: "blank",
            addClass: "blank"
        }
    },
    featuredContent: {
        type: "FeaturedContent",
        options: {
            id: "featuredContent",
            catPath: Librarian.homepage.featuredContentName,
            showView: false,
            navImageType: "png",
            title: "homepage_showcase"
        }
    },
    // displays showcase with featured content
    showcase: {
        rowSpan: 2,
        type: "FeaturedContent",
        options: {
            id: "showcase",
            addClass: "showcase",
            catPath: Librarian.homepage.featuredContentName,
            showView: false,
            navImageType: "png",
            title: "homepage_showcase"
        }
    },
    // shows recent responses, opens portal tracker
    responses: {  
        rowSpan: 2, 
        type: "RecentActivity", 
        options: {
            id: "responses",
            addClass: "responses",
            count: 3, 
            dayRange: 28, 
            title: "homepage_responding"
        }
    },
    links: {
        type: "Links",
        options: {
            id: "links"
        }
    },
    // displays html file (intended for a list of links)
    quickLinks: {
        type: "HTML",
        rowSpan: 2, 
        options: {
            id: "quickLinks",
            title: "Quick Links",
            fileName: "QuickLinks.html"
        }
    }, 
    // google maps api, pulls from XML file
    graph: {
        type: "Graph",
        rowSpan: 2,
        options: {
            id: "graph"
        }
    }, 
    // embeds graph of file popularity by month
    filePopularity: {
        type: "Chart", 
        rowSpan: 2, 
        options: {  
            chartName: "FilePopularity",
            postData: "e3VuaXRPZlRpbWU6ICdtbSd9",
            id: "filePopulartyReport", 
            data: {
                "fid": -1, 
                "in": "json", 
                "splitseries": true
            }, 
            monthDateRange: 5
        }
    },
    // embeds graph of content popularity by month
    contentPopularity: {
        type: "Chart", 
        rowSpan: 2, 
        options: {  
            chartName: "ContentPopularity",
            postData: "e3VuaXRPZlRpbWU6ICdtbSd9", 
            id: "contentPopulartyReport",
            data: {
                "in": "json"
            }, 
            monthDateRange: 5
        }
    },
    // embeds iframe into module
    iframe: {
        type: "iFrame", 
        rowSpan: 2, 
        options: {
            id: "iframe",
            src: null,
            css: {
                "height": "100%", 
                "width": "100%"
            } 
        }
    },
    // shows list of top opportunities
    opportunities: {
        type: "Opportunities", 
        rowSpan: 2, 
        options: {
            title: "<span>Top</span> Opportunities",
            id: "topOpportunities",
            addClass: "top-opportunities",
            embedInModule: true, 
            embedHeight: 303,
            openTabOnClick: true,
            tabName: "Opportunities"
        }
    },
    // show link list of popular content (size 2x2)
    popularContentLinksSquare: {
        rowSpan: 2,
        type: "PopularContentLinks",
        options: {
            id: "popularContentLinksSquare", 
            title: "Popular Content",
            isSquare: true
        }
    },
    // show link list of recent files (size 2x2)
    recentFilesLinksSquare: {
        rowSpan: 2,
        type: "RecentFilesLinks",
        options: {
            id: "recentFilesLinksSquare", 
            title: "homepage_recent",
            isSquare: true
        }
    },
    // show link list of recent files (size 2x2)
    recentGroupsLinksSquare: {
        rowSpan: 2,
        type: "RecentGroupsLinks",
        options: {
            id: "recentGroupsLinksSquare", 
            title: "homepage_recent",
            isSquare: true
        }
    },
    // show link list of favorites (size 2x2)
    favoritesLinksSquare: {
        rowSpan: 2,
        type: "FavoritesLinks",
        options: {
            id: "favoritesLinksSquare",
            title: "homepage_favorites",
            isSquare: true
        }
    },
    // show link list of urls from a specific destination (using ccid)
    categoryLinksSquare: {
        rowSpan: 2,
        type: "CategoryLinks",
        options: {
            id: "categoryLinksSquare",
            title: "File Bank",
            isSquare: true
        }
    },
     // show link list of recent files (size 2x2)
    collaboratioTopics: {
        rowSpan: 2,
        type: "CollaborationTopics",
        options: {
            id: "collaborationTopics", 
            title: "homepage_topics",
            isSquare: true
        }
    },
    // show embeded youtube video
    youtube: {
        rowSpan: 2,
        type: "YouTube",
        options: {
            id: "youtube",

            // pick one:

            // embed single video
            videoId: "",
            // embed playlist
            playlistId: "",
            // embed uploaded videos from user
            username: ""
        }
    },

    /* Column Modules (only for Grid2) */

    // shows link list of popular content
    popularContentLinks: {
        rowSpan: 2, 
        type: "PopularContentLinks",
        options: {
            id: "popularContentLinks", 
            title: "Hot Files",
            isSquare: false
        }
    },
    // shows link list of favorite content
    favoritesLinks: {
        rowSpan: 2, 
        type: "FavoritesLinks",
        options: {
            id: "favoritesLinks", 
            title: "homepage_favorites",
            isSquare: false
        }
    }, 
    // shows link list of recent content
    recentFilesLinks: {
        rowSpan: 2, 
        type: "RecentFilesLinks",
        options: {
            id: "recentFilesLinks", 
            title: "Recent",
            isSquare: false
        }
    },

    /* Deprecated Modules (kept for backwards compatibility) */

    // opens wizards folder (use "openCat" instead)
    wizards: {
        type: "Wizards",
        options: {
            id: "wizards",
            addClass: "wizards",
            label: "Wizards",
            folderPath: "MasterLibrary/Wizards"
        }
    },
    // empty module with no functionality (use "blank" instead)
    module: {
        type: "Module", 
        options: {
            id: "module"
        }
    },
    // same as module (use largeBlank)
    largeModule: {
        type: "Module", 
        rowSpan: 2,
        options: {
            id: "module"
        }
    },

    placeholder: {
        type: "placeholder"
    }

}
